import { Base } from '@gate31/core/src/libs/BaseComponent';
import { LoginAccountPhone } from '@gate31/feature/LoginAccountPhone/LoginAccountPhone';

export class LoginAccountPhoneDesk extends LoginAccountPhone {
    static cn = new Base.BuildCn('LoginAccountPhoneDesk');
}
